/**
 * Check if a given object implements the CreateTicketTemplateResponse interface.
 */
export function instanceOfCreateTicketTemplateResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
export function CreateTicketTemplateResponseFromJSON(json) {
    return CreateTicketTemplateResponseFromJSONTyped(json, false);
}
export function CreateTicketTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function CreateTicketTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
